import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";

interface decodeJWT {
  UserProfile: string;
}
export const getUserRoleByToken = (token: string) => {
  try {
    const decode: decodeJWT = jwtDecode(token);
    if (decode?.UserProfile) {
      return JSON.parse(decode?.UserProfile)?.UserRole;
    }
  } catch (error) {
    return "";
  }
};

export const getRedirectRoute = (role: string) => {
  return "/dashboard";
};

export const checkStrLen = (str: string) => {
  return String(str).trim().length;
};

export const getBase64 = async (file: File): Promise<string> => {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader?.result as string);
    };
    reader.onerror = reject;
  });
};

export const downloadFile = (value: string) => {
  const linkSource = value;
  const downloadLink = document.createElement("a");

  downloadLink.href = linkSource;
  downloadLink.download = "download";
  downloadLink.click();
};

export const getStatusColor = (status: any) => {
  if (status === "Pending") {
    return "warning";
  } else if (
    status === "Active" ||
    status === "Completed" ||
    status === "Paid" ||
    status === false
  ) {
    return "success";
  } else if (status === "Invalid" || status === "Blocked" || status === true) {
    return "error";
  }
};

export function formatSierraLeoneLeone(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "SLE",
  }).format(amount);
}

export const formatLabel = (key: string) =>
  key
    .replace(/([A-Z])/g, " $1") // insert space before capitals
    .replace(/^./, (s) => s.toUpperCase()); // capitalize first letter

export const formatValue = (key: string, value: any) => {
  const lowerKey = key.toLowerCase();
  if (lowerKey.includes("date") && dayjs(value).isValid()) {
    return dayjs(value).format("DD/MM/YYYY HH:mm:ss");
  } else if (lowerKey.includes("amount") && value) {
    return formatSierraLeoneLeone(value);
  }
  return value;
};

export type FileObject = {
  customerId: number;
  fileName: string;
  fileType: string;
  id: number;
  imageData: string;
};

export function createBase64DataURL(file: FileObject): string {
  const { fileName, fileType, imageData } = file;

  const mimeTypeMap: Record<string, string> = {
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    gif: "image/gif",
    pdf: "application/pdf",
    base64: "application/octet-stream",
  };

  const extension = fileName?.includes(".")
    ? fileName.split(".").pop()!.toLowerCase()
    : "";
  const mimeType =
    mimeTypeMap[extension] ||
    mimeTypeMap[fileType] ||
    "application/octet-stream";

  return `data:${mimeType};base64,${imageData}`;
}
